module.exports = __webpack_public_path__ + "static/media/data_science.91658d42.svg";